/**
 * Shared lead enums — single source of truth for both the public website
 * registration form and the admin lead import parser. Keep this list in sync
 * with the Import_Leads_Template_v5.xlsx dropdowns.
 */

export const MEDICAL_CONCERN_VALUES = [
  'Health Checkup',
  'Cardiology',
  'Gastroenterology',
  'Orthopedics & Spine',
  'Brain, Nerves & Stroke',
  'Oncology',
  'Others',
] as const;
export type MedicalConcern = (typeof MEDICAL_CONCERN_VALUES)[number];

export const AGENT_CODE_VALUES = ['MET', 'INS', 'GOV', 'PER', 'VRG'] as const;
export type AgentCodeEnum = (typeof AGENT_CODE_VALUES)[number];

export const AGENT_CODE_LABELS: Record<AgentCodeEnum, string> = {
  MET: 'Metropolitan',
  INS: 'Insurance Partner',
  GOV: 'Government / Public Sector',
  PER: 'Personal Referral',
  VRG: 'Vietravel Group',
};

export const GENDER_VALUES = ['male', 'female', 'other'] as const;
export type GenderEnum = (typeof GENDER_VALUES)[number];

export function isMedicalConcern(value: string): value is MedicalConcern {
  return (MEDICAL_CONCERN_VALUES as readonly string[]).includes(value);
}

export function isAgentCode(value: string): value is AgentCodeEnum {
  return (AGENT_CODE_VALUES as readonly string[]).includes(value);
}

export function isGender(value: string): value is GenderEnum {
  return (GENDER_VALUES as readonly string[]).includes(value);
}